export const CHAT_FRAME_ROUTE_NAME = 'dandy_chat_frame';
export const CHAT_FRAME_ROUTE = `/${CHAT_FRAME_ROUTE_NAME}`;
export const KUSTOMER_FRAME_ROUTE_NAME = 'kustomer_frame';
export const KUSTOMER_FRAME_ROUTE = `/${KUSTOMER_FRAME_ROUTE_NAME}`;
export const CST_FRAME_ROUTE_NAME = 'dandy_cst_frame';
export const CST_FRAME_ROUTE = `/${CST_FRAME_ROUTE_NAME}`;

export const ALL_CHAT_ROUTES = [CHAT_FRAME_ROUTE, KUSTOMER_FRAME_ROUTE, CST_FRAME_ROUTE];
